<template>
  <div class="recuperar-senha-container">
    <RecuperarSenhaIdentificacao
      v-if="step === 0"
      @submit="submitIdentificacao"
      @voltar="voltar"
    />
    <RecuperarSenhaConfirmar
      v-else-if="step === 1"
      :contatos="contatos"
      @submit="submitConfirmar"
      @voltar="voltar"
      @questionario="exibeQuestionario"
    />
    <RecuperarSenhaCodigo
      v-else-if="step === 2"
      :contato="contatoSelecionado"
      @submit="submitCodigo"
      @voltar="voltar"
    />
    <RecuperarSenhaQuestionario
      v-else-if="step === 3"
      @submit="submitCodigo"
      @voltar="atHome"
      @retry="atHome"
    />
    <RecuperarSenhaNovaSenha
      v-else-if="step === 4"
      @submit="submitNovaSenha"
      @voltar="atHome"
    />
  </div>
</template>

<script>
import RecuperarSenhaIdentificacao from '@/views/137/etapas/RecuperarSenhaIdentificacao'
import RecuperarSenhaConfirmar from '@/views/137/etapas/RecuperarSenhaConfirmar'
import { mapMutations, mapState, mapGetters } from 'vuex'
import RecuperarSenhaCodigo from '@/views/137/etapas/RecuperarSenhaCodigo'
import RecuperarSenhaNovaSenha from '@/views/137/etapas/RecuperarSenhaNovaSenha'
import { emmitTrocarPagina } from '@/utils/comandosSdk'
import RecuperarSenhaQuestionario from '@/views/137/etapas/RecuperarSenhaQuestionario'

export default {
  name: 'Func137RecuperarSenha',
  components: {
    RecuperarSenhaNovaSenha,
    RecuperarSenhaCodigo,
    RecuperarSenhaConfirmar,
    RecuperarSenhaIdentificacao,
    RecuperarSenhaQuestionario
  },
  data () {
    return {
      contatos: [],
      token: '',
      step: -1,
      contatoSelecionado: null
    }
  },
  computed: {
    ...mapState('SetupApp', ['frameId']),
    ...mapGetters('SetupApp', ['configuracaoAcesso']),
    funcData () {
      return this.configuracaoAcesso.recuperarSenha
    }
  },
  watch: {
    step (newValue) {
      switch (newValue) {
        case 1:
          this.comandoTrocaDePagina(this.funcData.parametros.textos.confirmarIdentidadeTituloNavegacao)
          break
        case 2:
          this.comandoTrocaDePagina(this.funcData.parametros.textos.confirmarCodigoTituloNavegacao)
          break
        case 3:
          this.comandoTrocaDePagina(this.funcData.parametros.textos.recuperarSenhaQuestionarioInicioTitulo)
          break
        case 4:
          this.comandoTrocaDePagina(this.funcData.parametros.textos.redefinirSenhaTituloNavegacao)
          break
        default:
          this.comandoTrocaDePagina(this.funcData.parametros.textos.esqueciSenhaTituloNavegacao)
      }
    }
  },
  methods: {
    ...mapMutations('Login', ['SET_TOKEN']),
    async init () {
      this.atHome()
    },
    submitIdentificacao (data) {
      this.contatos = data.contatos
      this.token = data.token
      this.SET_TOKEN(this.token)
      this.step = 1
    },
    submitConfirmar (data) {
      this.contatoSelecionado = data
      this.step = 2
    },
    submitCodigo () {
      this.step = 4
    },
    submitNovaSenha () {
      return this.$router.push({ path: '/9' })
    },
    voltar () {
      if (this.step > 0) {
        this.step--
      } else {
        return this.$router.push({ path: '/9' })
      }
    },
    comandoTrocaDePagina (titulo) {
      emmitTrocarPagina(this.frameId, titulo)
    },
    exibeQuestionario () {
      this.step = 3
    },
    atHome () {
      this.step = 0
    }
  },
  beforeDestroy () {
    this.SET_TOKEN('')
  },
  mounted () {
    this.init()
  }
}
</script>

<style scoped>
.recuperar-senha-container {
  max-width: 450px;
  margin: 0 auto;
  min-height: 500px;
}
.recuperar-titulo {
  font: normal normal bold 26px/36px Open Sans;
  letter-spacing: 0;
  color: #333333;
  padding-top: 20px;
  padding-bottom: 20px;
}

.recuperar-cabecalho {
  letter-spacing: 0;
  color: #333333;
}

.recuperar-rodapé {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #333333;
  margin-bottom: 15px;
}

.recuperar-button-style {
  margin-bottom: 15px;
  width: 100%;
  margin-left: 0;
}

</style>
